module.exports = __webpack_public_path__ + "static/media/updated_annual.25fc8dda.svg";